export const catalog_matrix = [
  {form_key:'new_hospital_id', catalog_key:'hospitals'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]